type Coordinate = { lat: number, lng: number };
type CoordinateAndPopulation = {
  center: Coordinate,
  population: number
}

const cityCoordinateMap: Map<string, Coordinate> = new Map<string, Coordinate>();
cityCoordinateMap.set('Linköping', { lat: 58.4038594, lng: 15.5402315 });
cityCoordinateMap.set('Borlänge', { lat: 60.4763293, lng: 15.3776199 });
cityCoordinateMap.set('Karlstad', { lat: 59.3929131, lng: 13.4884978 })
cityCoordinateMap.set('Arjeplog', { lat: 66.0459434, lng: 17.8574342 });
cityCoordinateMap.set('Stockholm', { lat: 59.326242, lng: 17.8419722 });
cityCoordinateMap.set('Sundsvall', { lat: 62.396161, lng: 17.2231804 })

const generateRandomCoordinates = (baseCoordinates: Coordinate, toGenerate: number): Coordinate[] => {
  const randomize = () => {
    return (2 * Math.random() - 1) * 0.5;
  }

  const result: Coordinate[] = [];

  for (let i = 0; i < toGenerate; i++) {
    result.push({ lat: baseCoordinates.lat + randomize(), lng: baseCoordinates.lng + randomize() })
  }
  return result;
}

export const generateCoordinatesForCity = (city: string, toGenerate: number = 100): Coordinate[] => {
  const coordinates: Coordinate | undefined = cityCoordinateMap.get(city);
  if (coordinates === undefined) {
    return [];
  }
  return generateRandomCoordinates(coordinates, toGenerate);
}

export const generateDemoCoordinates = (): Coordinate[] => {
  return [
    ...generateCoordinatesForCity('Linköping', 10),
    ...generateCoordinatesForCity('Borlänge', 50),
    ...generateCoordinatesForCity('Arjeplog', 30),
    ...generateCoordinatesForCity('Karlstad', 250),
    ...generateCoordinatesForCity('Stockholm', 450),
    ...generateCoordinatesForCity('Sundsvall', 100)
  ]
}

export const getCitiesWithPopulation = (): CoordinateAndPopulation[] => {
  return [
    {
      center: cityCoordinateMap.get('Sundsvall')!,
      population: 45789
    },
    {
      center: cityCoordinateMap.get('Stockholm')!,
      population: 95454
    },
    { // borlänge
      center: cityCoordinateMap.get('Borlänge')!,
      population: 87232
    },
    { // linköping
      center: cityCoordinateMap.get('Linköping')!,
      population: 542432
    },
    { // Karlstad
      center: cityCoordinateMap.get('Karlstad')!,
      population: 8492
    },
    { // Arjeplog
      center: cityCoordinateMap.get('Arjeplog')!,
      population: 197
    }
  ]
}
